import React from "react";

const testimonials = [
    {
        name: "A student from Karenni state",
        description:
            `I am a Kayan girl from Karenni state. I am currently participating in the Women Researchers Online Program from University of Queensland (UQ) and Ah Nyar Institute. I am grateful to have received the Scholarship, which supports my studies and research efforts. In March 2024, I had the privilege of attending the Young Professionals Fellowship (YPF) Batch 2 at Ah Nyar Institute. This program has been instrumental in shaping my academic and professional journey. Ah Nyar Institute has provided a fantastic opportunity. It feels like being with a team that brings a fire to light the candle of knowledge and curiosity. The institute has been a beacon of inspiration and growth for me and many others. To anyone considering continuing their education, especially in challenging times, I say this: it is never too late to start again. Use the difficulties you face as steppingstones to reach your goals. Embrace the journey with resilience and determination, and you will find success.`,
        image: "/assets/images/testimonials/testimonial-1.png",
    },
    {
        name: "A YPF student from Dip in Community Development Course",
        description:
            `I’m Veronica, a student from Batch 2 (Dip in Community Development course). Firstly, let me share a bit about my educational journey. Like many others, I left school during my high school years when the COVID-19 crisis hit in 2019. Later, as the political situation worsened, I gave up being a student to uphold my beliefs as a CDM supporter. From that point on, my life felt like starting over. To continue my education, I relied on self-study and volunteered to both learn and teach. When the internet access was cut off, I moved to the town where I could join online classes. It was during this time that I discovered Ah Nyar Institute which offered a non-profit Diploma in Community Development. At Ah Nyar, I gained incredible knowledge that has shaped my journey. With the foundation I built there, I was able to secure a scholarship and now I am pursuing higher studies at a university.`,
        image: "/assets/images/testimonials/testimonial-3.png",
    },
];

export default function Testimonials() {
    return (
        <section className="container py-5">
            <h2 className="text-center fw-bold mb-5">Students’ Testimonials</h2>
            <div className="row g-4">
                {testimonials.map((t, i) => (
                    <div key={i} className="col-md-6">
                        <div className="d-flex shadow rounded overflow-hidden h-100">
                            <div className="flex-grow-1 p-4 bg-white">
                                <p className="mb-0" style={{ textAlign: 'justify' }}>{t.description}</p>
                            </div>
                            <div className="d-flex flex-column align-items-center justify-content-center p-3 bg-testimonials mt-5 rounded rounded-bottom-0 rounded-end-0 text-center" style={{ width: '220px' }}>
                                <img
                                    src={t.image}
                                    alt={t.name}
                                    className="rounded-circle mb-3"
                                    style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                                />
                                <strong>{t.name}</strong>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}
